import assign from 'lodash/assign';
import { CreditCardForm } from 'components/creditCardForm/creditCardForm';
import { CreditCardImage } from 'components/creditCardImage/creditCardImage';
import { InputContainer } from 'components/inputContainer/inputContainer';
import { PaypalSdkService } from '../../services/paypalSdk.service';
import template from './checkoutWithPaypalSdkAcp.html';

import './checkoutWithPaypalSdkAcp.scss';

export const CheckoutWithPaypalSdkAcp = angular
    .module('checkout.components.checkoutWithPaypalSdkAcp', [
        PaypalSdkService,
        CreditCardForm,
        CreditCardImage,
        InputContainer
    ])
    .component('checkoutWithPaypalSdkAcp', {
        template,
        bindings: {
            cartId: '<',
            bagId: '<'
        },
        controller: class PaypalAcpCtrl {
            constructor(paypalSdkService, $rootScope, $timeout) {
                angular.extend(this, { paypalSdkService });
                assign(this, {
                    $timeout
                });
                this.isSubmitting = false;
                // eslint-disable-next-line no-unused-vars
                $rootScope.$on('paypal-acp-submit-clicked', (event, args) => {
                    this.$timeout(() => {
                        this.isSubmitting = true;
                    });
                });
                // eslint-disable-next-line no-unused-vars
                $rootScope.$on('paypal-submit-error', (event, args) => {
                    this.$timeout(() => {
                        this.isSubmitting = false;
                    });
                });
                this.cardType = 'none';
                $rootScope.$on('paypal-card-type-change', (event, args) => {
                    this.$timeout(() => {
                        this.cardType = args.cardType;
                    });
                });
            }
            $onInit() {
                this.paypalSdkService.renderPaypalAcp(this.cartId, this.bagId);
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/checkoutWithPaypalSdkAcp/checkoutWithPaypalSdkAcp.js